import { Text } from '@sitecore-jss/sitecore-jss-nextjs';
import React from 'react';
import classNames from 'classnames/bind';
import styles from './SeasonDetail.module.scss';
import { ShowDetailsProps } from 'models/podcasts-types';
import Icon from 'components/helpers/Icon';

const cx = classNames.bind(styles);

const ShowSummaryWithLinks: React.FC<ShowDetailsProps> = (props) => {
  const { showDetails } = props;
  if (!showDetails) return null;
  const hasLinks = showDetails.spotify || showDetails.youTube || showDetails.applePodcasts || showDetails.pandora;

  return (
    <>
      {hasLinks && <Text className={cx('podcasts-show-summary')} field={{ value: showDetails.heading }} tag="p" />}
      {hasLinks && (
        <div className={cx('podcasts-show-links')}>
          {showDetails.spotify && (
            <a href={showDetails.spotify} target="_blank" aria-label="Listen on Spotify (opens in new window)">
              <Icon
                variant="podcastSpotify"
                role="img"
                ariaLabel="Listen on Spotify"
                className={cx('pod-cast-link-icon')}
              />
            </a>
          )}

          {showDetails.youTube && (
            <a href={showDetails.youTube} target="_blank" aria-label="Listen on YouTube (opens in new window)">
              <Icon
                variant="podcastYoutube"
                role="img"
                ariaLabel="Listen on YouTube"
                className={cx('pod-cast-link-icon')}
              />
            </a>
          )}

          {showDetails.applePodcasts && (
            <a
              href={showDetails.applePodcasts}
              target="_blank"
              aria-label="Listen on Apple Podcasts (opens in new window)"
            >
              <Icon
                variant="podcastAppleStore"
                role="img"
                ariaLabel="Listen on Apple Podcasts"
                className={cx('pod-cast-link-icon')}
              />
            </a>
          )}

          {showDetails.pandora && (
            <a href={showDetails.pandora} target="_blank" aria-label="Listen on Pandora (opens in new window)">
              <Icon
                variant="podcastPandora"
                role="img"
                ariaLabel="Listen on Pandora"
                className={cx('pod-cast-link-icon', 'pod-cast-link-pandora')}
              />
            </a>
          )}
        </div>
      )}{' '}
    </>
  );
};

export default ShowSummaryWithLinks;
